import React from "react"
import classnames from 'classnames'
import * as styles from "./menu.module.scss"

const Menu = ({ isOpen, onClick }: { isOpen: boolean; onClick: () => void }) => {
  return (
    <button onClick={onClick} type="button" className={classnames(styles.root, {
      [styles.isOpen]: isOpen
    })}>
      <span className={styles.burger}>
        <span className={styles.top}></span>
        <span className={styles.middle}></span>
        <span className={styles.extra}></span>
        <span className={styles.bottom}></span>
      </span>
    </button>
  )
}

export default Menu
